import { FormGroup } from '@angular/forms';
import { Component, OnInit, AfterViewInit, ActivatedRoute, Params } from '../../../ng';
import { ControllerForViewBase } from '../../framework/controller-for-view-base';
import { PageContainerService } from '../../../services';
import * as Data from '../../../data';

@Component({
  selector: 'create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss']
})
export class CreateAccountComponent extends ControllerForViewBase implements OnInit {
  createUserCommandRequest: Data.Web.CreateUserCommandRequest = <any>{};
  createUserCommandRequestForm = new FormGroup({});
  createUserCommandRequestFields = Data.Web.CreateUserCommandRequest.FormlyConfig;

  constructor(pcs: PageContainerService, private activatedRoute: ActivatedRoute) {
    super(pcs);
  }

  ngOnInit() {
    this.createUserCommandRequest.Roles = [{ Value: 0, Text: 'Admin' }];
  }

  async createUser() {
    await this.pcs.apiService.CreateUser(this.createUserCommandRequest, undefined, true);
    this.pcs.router.navigate(['login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/account/create-account/create-account.component.ts